const INTERCOM_ARTICLES = {
  FAQS: "https://help.340besp.com/en/articles/14482537-frequently-asked-questions-faqs",
  HOW_TO_OBTAIN_HIN: "https://help.340besp.com/en/articles/14482573-how-to-obtain-a-hin",
  HOW_TO_REVIEW_CLAIMS_DATA:
    "https://help.340besp.com/en/articles/17069695-how-to-review-submitted-claims-data-in-340b-esp",
  HOW_TO_SUBMIT_CLAIMS:
    "https://help.340besp.com/en/articles/17230435-how-to-submit-claims-data-in-340b-esp",
  CLAIMS_SUBMISSION_OVERVIEW:
    "https://help.340besp.com/en/articles/17230688-claims-submission-overview",
  WHICH_SUBMISSION_TYPE_TO_CHOOSE:
    "https://help.340besp.com/en/collections/19746531-claims-data-requirements",
};

export default INTERCOM_ARTICLES;
